(function () {
  'use strict';

  function initProductDetails() {
    document.querySelectorAll('[data-pk-product-details]').forEach(function (section) {
      if (section.dataset.pkPdInit) return;
      section.dataset.pkPdInit = 'true';

      var items = section.querySelectorAll('.pk-pd__item');
      items.forEach(function (item, index) {
        item.style.setProperty('--pk-pd-delay', String(index * 80) + 'ms');
      });

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0.08 }
      );

      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        section.classList.add('is-visible');
      } else {
        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetails);
  } else {
    initProductDetails();
  }

  document.addEventListener('shopify:section:load', initProductDetails);
})();
